var React = require('react');

function TopChat1 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{isolation:isolate;}.cls-2{fill:#182c71;mix-blend-mode:multiply;}")),React.createElement("g",{"className":"cls-1","key":1},React.createElement("g",{"id":"レイヤー_1","data-name":"レイヤー 1"},React.createElement("path",{"className":"cls-2","d":"M78.32.86,487.67,52.63C530.93,58.1,566,83.3,566,132.26V326.12c0,44-35.07,71.76-78.33,75.53l-94.35,8.22L426.56,494,297.88,418.18,78.32,437.3C35.07,441.07,0,407.18,0,353V89.09C0,39.92,30-3,78.32.86Z","style":{"fill":"#243B88"}})))]);
}

TopChat1.defaultProps = {"viewBox":"0 0 566 494"};

module.exports = TopChat1;

TopChat1.default = TopChat1;
